import { render, staticRenderFns } from "./DeliveryFounderConsultList.vue?vue&type=template&id=3dfaf905&"
import script from "./DeliveryFounderConsultList.vue?vue&type=script&lang=ts&"
export * from "./DeliveryFounderConsultList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports